export enum VirtualMetricOPEEnum {
  GetVirtualMetricInstances = 'getVirtualMetricInstances',
  GetVirtualMetrics = 'getVirtualMetrics',
  PutVirtualMetric = 'putVirtualMetric',
  DuplicateVirtualMetric = 'duplicateVirtualMetric',
  DelVirtualMetric = 'delVirtualMetric',
  CheckVirtualMetricExpression = 'checkVirtualMetricExpression'

}
